
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rates/spastays/[id]",
      function () {
        return require("private-next-pages/rates/spastays/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rates/spastays/[id]"])
      });
    }
  